import { startCase } from "lodash";

export const encodeTemplateUserRoleLabel = (label: string) =>
  startCase(label.trim()).replace(/[^A-Za-z0-9]/g, "");

export const decodeTemplateUserRoleAlias = (alias: string) =>
  alias.replace(/([a-z])([A-Z])/g, "$1 $2");
